import { IOption } from "../../components/SelectDropdown";
import { diagnosisService } from "../../services/diagnosisService";

/**
 * Searches SNOMED diagnoses server-side and maps them to the option shape used
 * by SnomedSelect. The full diagnosis list (tens of thousands of rows) is never
 * fetched to the client.
 */
export async function searchDiagnosisOptions(
  search: string,
  limit = 50
): Promise<IOption[]> {
  const { data } = await diagnosisService.searchDiagnoses(search, limit);

  return data.map((diagnosis) => ({
    label: `${diagnosis.preferredTerm} - ${diagnosis.conceptId}`,
    value: diagnosis.conceptId.toString(),
    key: `diagnosis-${diagnosis.conceptId}`,
  }));
}
